<template>
  <div class="col-md-4 dragme" v-if="data.access > 2">
    <div class="portlet light">
      <i class="fa fa-arrows-alt arrow-move" aria-hidden="true"></i>
      <div class="module-name">Top 5 Reports</div>
      <div class="portlet-title">
        <div class="caption caption-md">
          <i class="icon-bar-chart font-dark hide"></i>
          <span class="caption-subject font-dark bold uppercase">Top 5 Reports</span>
        </div>
      </div>
      <div class="portlet-body" style="height: 300px; overflow: hidden;" v-bar>
        <div class="table-scrollable table-scrollable-borderless" v-if="data.access > 2">
          <table class="table table-hover table-light">
            <thead>
            <tr class="uppercase">
              <th> REPORT NAME </th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, idx) in data.top_reports">
              <td><router-link :to="{ name: 'Reports Preview', params: { reportid: item.id } }" tag="a" >{{ item.name }} </router-link></td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="btn-arrow-link pull-right">
          <router-link :to="{ name: 'Reports Index', params: { reset: true }}" tag="a" class="text-warning">VIEW|EDIT
            <i class="icon-arrow-right black"></i>
          </router-link>
        </div>
      </div>
      <div class="clearfix"></div>
    </div>
  </div>
</template>
<script>
  import {mapGetters} from 'vuex';
  export default {
    props: ['mode'],

    data() {
      return {
        status: ['Active', 'Follow-Up', 'Pending', 'Waitlist']
      }
    },
    computed: {
      ...mapGetters({
        data: 'getOrganizationDashboard'
      }),
    },
  }
</script>
<style scoped>
  .dragme .table-scrollable {
    margin-top:-10px !important;
    height: calc(100% - 20px) !important;
  }
</style>



// WEBPACK FOOTER //
// TopReports.vue?fff3cd78